/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConfig200ResponseLegalEntity
 */
export interface GetConfig200ResponseLegalEntity {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseLegalEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseLegalEntity
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseLegalEntity
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseLegalEntity
     */
    taxId: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseLegalEntity
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseLegalEntity
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseLegalEntity
     */
    number?: string;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200ResponseLegalEntity
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200ResponseLegalEntity
     */
    longitude?: number;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseLegalEntity
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseLegalEntity
     */
    regionCode: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseLegalEntity
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseLegalEntity
     */
    provinceCode?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseLegalEntity
     */
    neighborhood?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseLegalEntity
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseLegalEntity
     */
    province?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseLegalEntity
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseLegalEntity
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseLegalEntity
     */
    iban?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseLegalEntity
     */
    additionalInformation?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponseLegalEntity
     */
    deleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseLegalEntity
     */
    payoutInterval: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponseLegalEntity
     */
    isTaxExempt: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseLegalEntity
     */
    taxExemptionReason?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseLegalEntity
     */
    entityType?: string;
}

/**
 * Check if a given object implements the GetConfig200ResponseLegalEntity interface.
 */
export function instanceOfGetConfig200ResponseLegalEntity(value: object): value is GetConfig200ResponseLegalEntity {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('taxId' in value) || value['taxId'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('regionCode' in value) || value['regionCode'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('deleted' in value) || value['deleted'] === undefined) return false;
    if (!('payoutInterval' in value) || value['payoutInterval'] === undefined) return false;
    if (!('isTaxExempt' in value) || value['isTaxExempt'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseLegalEntityFromJSON(json: any): GetConfig200ResponseLegalEntity {
    return GetConfig200ResponseLegalEntityFromJSONTyped(json, false);
}

export function GetConfig200ResponseLegalEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseLegalEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationId': json['organizationId'],
        'companyName': json['companyName'],
        'taxId': json['taxId'],
        'address': json['address'],
        'street': json['street'] == null ? undefined : json['street'],
        'number': json['number'] == null ? undefined : json['number'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'regionCode': json['regionCode'],
        'countryCode': json['countryCode'],
        'provinceCode': json['provinceCode'] == null ? undefined : json['provinceCode'],
        'neighborhood': json['neighborhood'] == null ? undefined : json['neighborhood'],
        'city': json['city'] == null ? undefined : json['city'],
        'province': json['province'] == null ? undefined : json['province'],
        'country': json['country'] == null ? undefined : json['country'],
        'email': json['email'],
        'iban': json['iban'] == null ? undefined : json['iban'],
        'additionalInformation': json['additionalInformation'] == null ? undefined : json['additionalInformation'],
        'deleted': json['deleted'],
        'payoutInterval': json['payoutInterval'],
        'isTaxExempt': json['isTaxExempt'],
        'taxExemptionReason': json['taxExemptionReason'] == null ? undefined : json['taxExemptionReason'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
    };
}

export function GetConfig200ResponseLegalEntityToJSON(json: any): GetConfig200ResponseLegalEntity {
    return GetConfig200ResponseLegalEntityToJSONTyped(json, false);
}

export function GetConfig200ResponseLegalEntityToJSONTyped(value?: GetConfig200ResponseLegalEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organizationId': value['organizationId'],
        'companyName': value['companyName'],
        'taxId': value['taxId'],
        'address': value['address'],
        'street': value['street'],
        'number': value['number'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'postalCode': value['postalCode'],
        'regionCode': value['regionCode'],
        'countryCode': value['countryCode'],
        'provinceCode': value['provinceCode'],
        'neighborhood': value['neighborhood'],
        'city': value['city'],
        'province': value['province'],
        'country': value['country'],
        'email': value['email'],
        'iban': value['iban'],
        'additionalInformation': value['additionalInformation'],
        'deleted': value['deleted'],
        'payoutInterval': value['payoutInterval'],
        'isTaxExempt': value['isTaxExempt'],
        'taxExemptionReason': value['taxExemptionReason'],
        'entityType': value['entityType'],
    };
}

